export default __webpack_public_path__ + "static/media/ramoji-film-city-1.2788200d.jpg";